<template>
  <div v-loading="isLoading">
    <el-row id="content-title">
      <el-col :sm="18" :xs="24">
        <div class="d-flex align-items-center">
          <h3 class="mb-0">Repair - ULD In / Job Order</h3>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <router-view :key="$route.fullPath"></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {}
};
</script>

<style lang="css" scoped></style>
